// @ts-nocheck
import React from 'react';

import { ReactComponent as arrowDown } from './../../assets/icons/arrow-down.svg';
import { ReactComponent as arrowLeft } from './../../assets/icons/arrow-left.svg';
import { ReactComponent as arrowRight } from './../../assets/icons/arrow-right.svg';
import { ReactComponent as arrowLeftSmall } from './../../assets/icons/arrow-left-small.svg';
import { ReactComponent as arrowRightSmall } from './../../assets/icons/arrow-right-small.svg';
import { ReactComponent as calendar } from './../../assets/icons/calendar.svg';
import { ReactComponent as cancel } from './../../assets/icons/cancel.svg';
import { ReactComponent as clipboard } from './../../assets/icons/clipboard.svg';
import { ReactComponent as close } from './../../assets/icons/closeIcon.svg';
import { ReactComponent as dottedCircle } from './../../assets/icons/dotted-circle.svg';
import { ReactComponent as circledCheckmark } from './../../assets/icons/circled-checkmark.svg';

// Header Icon

import {ReactComponent as userSideMenuIcon} from "./../../assets/icons/user-icon.svg"
import {ReactComponent as patientSideMenuIcon} from "./../../assets/icons/patient-side-menu-icon.svg"
import {ReactComponent as reportSideMenuIcon} from "./../../assets/icons/report-side-menu-icon.svg"
import {ReactComponent as studiesSideMenuIcon} from "./../../assets/icons/studies-side-menu-icon.svg"
import {ReactComponent as createTemplateSideMenuIcon} from "./../../assets/icons/create-template-side-menu-icon.svg"
import {ReactComponent as appointmentSideMenuIcon} from "./../../assets/icons/appointment-side-menu-icon.svg"
import {ReactComponent as auditTrailSideMenuIcon} from "./../../assets/icons/audit-trail-side-menu-icon.svg"
import {ReactComponent as profileSideMenuIcon} from "./../../assets/icons/user-profile-side-menu-icon.svg"
import {ReactComponent as hospitalSideMenuIcon} from "./../../assets/icons/hospital-side-menu-icon.svg"
import {ReactComponent as dashboardSideMenuIcon} from "./../../assets/icons/dashboard-side-menu-icon.svg"
import {ReactComponent as profileEditSideMenuIcon} from "./../../assets/icons/profile-side-icon.svg"
import {ReactComponent as settingSideMenuIcon} from "./../../assets/icons/settings-side-menu-icon.svg"

import { ReactComponent as chevronDown } from './../../assets/icons/chevron-down.svg';
import { ReactComponent as chevronLeft } from './../../assets/icons/chevron-left.svg';
import { ReactComponent as chevronMenu } from './../../assets/icons/chevron-menu.svg';
import { ReactComponent as chevronNext } from './../../assets/icons/chevron-next.svg';
import { ReactComponent as chevronPrev } from './../../assets/icons/chevron-prev.svg';
import { ReactComponent as chevronRight } from './../../assets/icons/chevron-right.svg';
import { ReactComponent as contentNext } from './../../assets/icons/content-next.svg';
import { ReactComponent as contentPrev } from './../../assets/icons/content-prev.svg';
import { ReactComponent as eyeVisible } from './../../assets/icons/eye-visible.svg';
import { ReactComponent as eyeHidden } from './../../assets/icons/eye-hidden.svg';
import { ReactComponent as exclamation } from './../../assets/icons/exclamation.svg';
import { ReactComponent as externalLink } from './../../assets/icons/external-link.svg';
import { ReactComponent as groupLayers } from './../../assets/icons/group-layers.svg';
import { ReactComponent as info } from './../../assets/icons/info.svg';
import { ReactComponent as infoAction } from './../../assets/icons/info-action.svg';
import { ReactComponent as infoLink } from './../../assets/icons/info-link.svg';
import { ReactComponent as launchArrow } from './../../assets/icons/launch-arrow.svg';
import { ReactComponent as launchInfo } from './../../assets/icons/launch-info.svg';
import { ReactComponent as link } from './../../assets/icons/tool-stack-image-sync.svg';
import { ReactComponent as listBullets } from './../../assets/icons/list-bullets.svg';
import { ReactComponent as lock } from './../../assets/icons/lock.svg';
import { ReactComponent as logoOhifSmall } from './../../assets/icons/logo-ohif-small.svg';
import { ReactComponent as logoDarkBackGround } from './../../assets/icons/ohif-logo-color-darkbg.svg';
import { ReactComponent as magnifier } from './../../assets/icons/magnifier.svg';
import { ReactComponent as notificationwarningDiamond } from './../../assets/icons/notificationwarning-diamond.svg';
import { ReactComponent as pencil } from './../../assets/icons/pencil.svg';
import { ReactComponent as powerOff } from './../../assets/icons/power-off.svg';
import { ReactComponent as profile } from './../../assets/icons/profile.svg';
import { ReactComponent as pushLeft } from './../../assets/icons/push-left.svg';
import { ReactComponent as pushRight } from './../../assets/icons/push-right.svg';
import { ReactComponent as settings } from './../../assets/icons/settings.svg';
import { ReactComponent as sidePanelCloseLeft } from './../../assets/icons/side-panel-close-left.svg';
import { ReactComponent as sidePanelCloseRight } from './../../assets/icons/side-panel-close-right.svg';
import { ReactComponent as sorting } from './../../assets/icons/sorting.svg';
import { ReactComponent as sortingActiveDown } from './../../assets/icons/sorting-active-down.svg';
import { ReactComponent as sortingActiveUp } from './../../assets/icons/sorting-active-up.svg';
import { ReactComponent as statusAlertWarning } from './../../assets/icons/status-alert-warning.svg';
import { ReactComponent as statusAlert } from './../../assets/icons/status-alert.svg';
import { ReactComponent as statusLocked } from './../../assets/icons/status-locked.svg';
import { ReactComponent as statusTracked } from './../../assets/icons/status-tracked.svg';
import { ReactComponent as statusUntracked } from './../../assets/icons/status-untracked.svg';
import { ReactComponent as tracked } from './../../assets/icons/tracked.svg';
import { ReactComponent as unlink } from './../../assets/icons/unlink.svg';
import { ReactComponent as checkboxChecked } from './../../assets/icons/checkbox-checked.svg';
import { ReactComponent as checkboxUnchecked } from './../../assets/icons/checkbox-unchecked.svg';
import { ReactComponent as iconAlertOutline } from './../../assets/icons/icons-alert-outline.svg';
import { ReactComponent as iconAlertSmall } from './../../assets/icons/icon-alert-small.svg';
import { ReactComponent as iconClose } from './../../assets/icons/icon-close.svg';
import { ReactComponent as iconClearField } from './../../assets/icons/icon-clear-field.svg';
import { ReactComponent as iconNextInactive } from './../../assets/icons/icon-next-inactive.svg';
import { ReactComponent as iconNext } from './../../assets/icons/icon-next.svg';
import { ReactComponent as iconPlay } from './../../assets/icons/icon-play.svg';
import { ReactComponent as iconPause } from './../../assets/icons/icon-pause.svg';
import { ReactComponent as iconPrevInactive } from './../../assets/icons/icon-prev-inactive.svg';
import { ReactComponent as iconPrev } from './../../assets/icons/icon-prev.svg';
import { ReactComponent as iconSearch } from './../../assets/icons/icon-search.svg';
import { ReactComponent as iconStatusAlert } from './../../assets/icons/icon-status-alert.svg';
import { ReactComponent as iconTransferring } from './../../assets/icons/icon-transferring.svg';
import { ReactComponent as iconUpload } from './../../assets/icons/icon-upload.svg';
import { ReactComponent as navigationPanelRightHide } from './../../assets/icons/navigation-panel-right-hide.svg';
import { ReactComponent as navigationPanelRightReveal } from './../../assets/icons/navigation-panel-right-reveal.svg';
import { ReactComponent as tabLinear } from './../../assets/icons/tab-linear.svg';
import { ReactComponent as tabPatientInfo } from './../../assets/icons/tab-patient-info.svg';
import { ReactComponent as tabROIThreshold } from './../../assets/icons/tab-roi-threshold.svg';
import { ReactComponent as tabSegmentation } from './../../assets/icons/tab-segmentation.svg';
import { ReactComponent as tabStudies } from './../../assets/icons/tab-studies.svg';
import { ReactComponent as uiArrowDown } from './../../assets/icons/ui-arrow-down.svg';
import { ReactComponent as uiArrowUp } from './../../assets/icons/ui-arrow-up.svg';
import { ReactComponent as uiArrowLeft } from './../../assets/icons/ui-arrow-left.svg';
import { ReactComponent as uiArrowRight } from './../../assets/icons/ui-arrow-right.svg';
import { ReactComponent as loadingOHIFMark } from './../../assets/icons/loading-ohif-mark.svg';
import { ReactComponent as notificationsInfo } from './../../assets/icons/notifications-info.svg';
import { ReactComponent as notificationsWarning } from './../../assets/icons/notifications-warning.svg';
import { ReactComponent as notificationsError } from './../../assets/icons/notifications-error.svg';
import { ReactComponent as notificationsSuccess } from './../../assets/icons/notifications-success.svg';
import { ReactComponent as nextArrow } from './../../assets/icons/next-arrow.svg';
import { ReactComponent as prevArrow } from './../../assets/icons/prev-arrow.svg';
import { ReactComponent as viewportStatusTracked } from './../../assets/icons/viewport-status-tracked.svg';
import { ReactComponent as toggleDicomOverlay } from './../../assets/icons/tool-toggle-dicom-overlay.svg';
import { ReactComponent as toolZoom } from './../../assets/icons/tool-zoom.svg';
import { ReactComponent as toolCapture } from './../../assets/icons/tool-capture.svg';
import { ReactComponent as toolLayout } from './../../assets/icons/tool-layout-default.svg';
import { ReactComponent as toolMore } from './../../assets/icons/tool-more-menu.svg';
import { ReactComponent as toolMove } from './../../assets/icons/tool-move.svg';
import { ReactComponent as toolWindow } from './../../assets/icons/tool-window-level.svg';
import { ReactComponent as toolAnnotate } from './../../assets/icons/tool-annotate.svg';
import { ReactComponent as annotationPreference } from './../../assets/icons/annotation-preference.svg';
import { ReactComponent as toolBidirectional } from './../../assets/icons/tool-bidirectional.svg';
import { ReactComponent as toolElipse } from './../../assets/icons/tool-measure-elipse.svg';
import { ReactComponent as toolCircle } from './../../assets/icons/tool-circle.svg';
import { ReactComponent as toolLength } from './../../assets/icons/tool-length.svg';
import { ReactComponent as toolStackScroll } from './../../assets/icons/tool-stack-scroll.svg';
import { ReactComponent as toolMagnify } from './../../assets/icons/tool-quick-magnify.svg';
import { ReactComponent as toolFlipHorizontal } from './../../assets/icons/tool-flip-horizontal.svg';
import { ReactComponent as toolInvert } from './../../assets/icons/tool-invert.svg';
import { ReactComponent as toolRotateRight } from './../../assets/icons/tool-rotate-right.svg';
import { ReactComponent as toolCine } from './../../assets/icons/tool-cine.svg';
import { ReactComponent as toolCrosshair } from './../../assets/icons/tool-crosshair.svg';
import { ReactComponent as toolProbe } from './../../assets/icons/focus-frame-target.svg';
import { ReactComponent as toolAngle } from './../../assets/icons/tool-angle.svg';
import { ReactComponent as toolReset } from './../../assets/icons/tool-reset.svg';
import { ReactComponent as toolRectangle } from './../../assets/icons/tool-rectangle.svg';
import { ReactComponent as toolFusionColor } from './../../assets/icons/tool-fusion-color.svg';
import { ReactComponent as toolCreateThreshold } from './../../assets/icons/tool-create-threshold.svg';
import { ReactComponent as toolCalibration } from './../../assets/icons/tool-calibrate.svg';
import { ReactComponent as toolFreehand } from './../../assets/icons/tool-freehand.svg';
import { ReactComponent as toolFreehandPolygon } from './../../assets/icons/tool-freehand-polygon.svg';
import { ReactComponent as toolPolygon } from './../../assets/icons/tool-polygon.svg';
import { ReactComponent as editPatient } from './../../assets/icons/edit-patient.svg';
import { ReactComponent as panelGroupMore } from './../../assets/icons/panel-group-more.svg';
import { ReactComponent as panelGroupOpenClose } from './../../assets/icons/panel-group-open-close.svg';
import { ReactComponent as rowAdd } from './../../assets/icons/row-add.svg';
import { ReactComponent as rowEdit } from './../../assets/icons/row-edit.svg';
import { ReactComponent as rowHidden } from './../../assets/icons/row-hidden.svg';
import { ReactComponent as rowShown } from './../../assets/icons/row-shown.svg';
import { ReactComponent as rowLock } from './../../assets/icons/row-lock.svg';
import { ReactComponent as rowUnlock } from './../../assets/icons/row-unlock.svg';
import { ReactComponent as iconMPR } from './../../assets/icons/icon-mpr-alt.svg';
import { ReactComponent as checkboxDefault } from './../../assets/icons/checkbox-default.svg';
import { ReactComponent as checkboxActive } from './../../assets/icons/checkbox-active.svg';
import { ReactComponent as referenceLines } from './../../assets/icons/tool-reference-lines.svg';
import { ReactComponent as chevronDownNew } from './../../assets/icons/icon-disclosure-close.svg';
import { ReactComponent as chevronLeftNew } from './../../assets/icons/icon-disclosure-open.svg';
import { ReactComponent as settingsBars } from './../../assets/icons/icon-display-settings.svg';
import { ReactComponent as iconAdd } from './../../assets/icons/icon-add.svg';
import { ReactComponent as iconRename } from './../../assets/icons/icon-rename.svg';
import { ReactComponent as iconDelete } from './../../assets/icons/icon-delete.svg';
import { ReactComponent as iconMoreMenu } from './../../assets/icons/icon-more-menu.svg';
import { ReactComponent as iconToolBrush } from './../../assets/icons/tool-seg-brush.svg';
import { ReactComponent as iconToolEraser } from './../../assets/icons/tool-seg-eraser.svg';
import { ReactComponent as iconToolScissor } from './../../assets/icons/icon-tool-scissor.svg';
import { ReactComponent as iconToolShape } from './../../assets/icons/tool-seg-shape.svg';
import { ReactComponent as iconToolThreshold } from './../../assets/icons/tool-seg-threshold.svg';
import { ReactComponent as viewportWindowLevel } from './../../assets/icons/viewport-window-level.svg';
import { ReactComponent as dicomTagBrowser } from './../../assets/icons/tool-dicom-tag-browser.svg';
import { ReactComponent as iconToolFreehandRoi } from './../../assets/icons/tool-freehand-roi.svg';
import { ReactComponent as iconToolLivewire } from './../../assets/icons/tool-magnetic-roi.svg';
import { ReactComponent as iconToolSplineRoi } from './../../assets/icons/tool-spline-roi.svg';
import { ReactComponent as iconToolUltrasoundBidirectional } from './../../assets/icons/tool-ultrasound-bidirectional.svg';
import { ReactComponent as iconToolLoupe } from './../../assets/icons/tool-magnify.svg';
import { ReactComponent as oldTrash } from './../../assets/icons/old-trash.svg';
import { ReactComponent as oldPlay } from './../../assets/icons/old-play.svg';
import { ReactComponent as oldStop } from './../../assets/icons/old-stop.svg';
import { ReactComponent as iconColorLUT } from './../../assets/icons/icon-color-lut.svg';
import { ReactComponent as iconChevronPatient } from './../../assets/icons/icon-chevron-patient.svg';
import { ReactComponent as iconPatient } from './../../assets/icons/icon-patient.svg';
import { ReactComponent as iconSettings } from './../../assets/icons/icon-settings.svg';
import { ReactComponent as iconToolbarBack } from './../../assets/icons/icon-toolbar-back.svg';
import { ReactComponent as iconMultiplePatients } from './../../assets/icons/icon-multiple-patients.svg';
import { ReactComponent as layoutAdvanced3DFourUp } from './../../assets/icons/layout-advanced-3d-four-up.svg';
import { ReactComponent as layoutAdvanced3DMain } from './../../assets/icons/layout-advanced-3d-main.svg';
import { ReactComponent as layoutAdvanced3DOnly } from './../../assets/icons/layout-advanced-3d-only.svg';
import { ReactComponent as layoutAdvanced3DPrimary } from './../../assets/icons/layout-advanced-3d-primary.svg';
import { ReactComponent as layoutAdvancedAxialPrimary } from './../../assets/icons/layout-advanced-axial-primary.svg';
import { ReactComponent as layoutAdvancedMPR } from './../../assets/icons/layout-advanced-mpr.svg';
import { ReactComponent as layoutCommon1x1 } from './../../assets/icons/layout-common-1x1.svg';
import { ReactComponent as layoutCommon1x2 } from './../../assets/icons/layout-common-1x2.svg';
import { ReactComponent as layoutCommon2x2 } from './../../assets/icons/layout-common-2x2.svg';
import { ReactComponent as layoutCommon2x3 } from './../../assets/icons/layout-common-2x3.svg';
import { ReactComponent as iconToolRotate } from './../../assets/icons/tool-3d-rotate.svg';
import { ReactComponent as tab4D } from './../../assets/icons/tab-4d.svg';
import { ReactComponent as investigationalUse } from './../../assets/icons/illustration-investigational-use.svg';
import { ReactComponent as actionNewDialog } from './../../assets/icons/action-new-dialog.svg';
import { ReactComponent as iconToolCobbAngle } from './../../assets/icons/tool-cobb-angle.svg';
import { ReactComponent as iconToolWindowRegion } from './../../assets/icons/tool-window-region.svg';
import { ReactComponent as Microphone } from './../../assets/icons/microphone.svg';
import { ReactComponent as Stop } from './../../assets/icons/stop.svg';
import { ReactComponent as SuccessCircle } from './../../assets/icons/check-circle.svg'
import { ReactComponent as CrossIcon } from './../../assets/icons/cross-icon.svg'
import { ReactComponent as CheckIcon } from './../../assets/icons/selected.svg'
import {ReactComponent as studyReserachIcon} from "./../../assets/icons/research-menu-icon.svg"

import {ReactComponent as maleIcon} from "./../../assets/icons/maleIcon.svg";
import {ReactComponent as femaleIcon} from "./../../assets/icons/femaleIcon.svg";
import {ReactComponent as brain} from "./../../assets/icons/brain.svg";
import {ReactComponent as chestBones} from "./../../assets/icons/chestBones.svg";
import {ReactComponent as clinician} from "./../../assets/icons/clinician.svg";
import {ReactComponent as cardiologist} from "./../../assets/icons/cardiologist.svg";
import {ReactComponent as radiologist} from "./../../assets/icons/radiologist.svg";
import {ReactComponent as nurse} from "./../../assets/icons/nurse.svg";
import {ReactComponent as frontDesk} from "./../../assets/icons/frontDesk.svg";
import {ReactComponent as superAdmin} from "./../../assets/icons/superAdmin.svg";
import {ReactComponent as port} from "./../../assets/icons/port.svg";
import {ReactComponent as plan} from "./../../assets/icons/plan.svg";
import {ReactComponent as othersIcon} from "./../../assets/icons/othersIcon.svg";
import {ReactComponent as uploadImage} from "../../../assets/svgIcons/uploadImage.svg"
import { ReactComponent as maximizeIcon } from './../../assets/icons/maximize-icon.svg';
import { ReactComponent as verifyReport } from './../../assets/icons/verifyReport.svg'


import CTAAA from './../../assets/icons/CT-AAA.png';
import CTAAA2 from './../../assets/icons/CT-AAA2.png';
import CTAir from './../../assets/icons/CT-Air.png';
import CTBone from './../../assets/icons/CT-Bone.png';
import CTBones from './../../assets/icons/CT-Bones.png';
import CTCardiac from './../../assets/icons/CT-Cardiac.png';
import CTCardiac2 from './../../assets/icons/CT-Cardiac2.png';
import CTCardiac3 from './../../assets/icons/CT-Cardiac3.png';
import CTChestContrastEnhanced from './../../assets/icons/CT-Chest-Contrast-Enhanced.png';
import CTChestVessels from './../../assets/icons/CT-Chest-Vessels.png';
import CTCoronaryArteries from './../../assets/icons/CT-Coronary-Arteries.png';
import CTCoronaryArteries2 from './../../assets/icons/CT-Coronary-Arteries-2.png';
import CTCoronaryArteries3 from './../../assets/icons/CT-Coronary-Arteries-3.png';
import CTCroppedVolumeBone from './../../assets/icons/CT-Cropped-Volume-Bone.png';
import CTFat from './../../assets/icons/CT-Fat.png';
import CTLiverVasculature from './../../assets/icons/CT-Liver-Vasculature.png';
import CTLung from './../../assets/icons/CT-Lung.png';
import CTMIP from './../../assets/icons/CT-MIP.png';
import CTMuscle from './../../assets/icons/CT-Muscle.png';
import CTPulmonaryArteries from './../../assets/icons/CT-Pulmonary-Arteries.png';
import CTSoftTissue from './../../assets/icons/CT-Soft-Tissue.png';
import DTIFABrain from './../../assets/icons/DTI-FA-Brain.png';
import MRAngio from './../../assets/icons/MR-Angio.png';
import MRDefault from './../../assets/icons/MR-Default.png';
import MRMIP from './../../assets/icons/MR-MIP.png';
import MRT2Brain from './../../assets/icons/MR-T2-Brain.png';
import VolumeRendering from './../../assets/icons/VolumeRendering.png';
import LoginBgImage from './../../assets/icons/dsn-bg.png';
import LockIcon from './../../assets/icons/lock_icon.svg';
import MailIcon from './../../assets/icons/mail_icon.svg';
import WebsiteIcon from './../../assets/icons/website-icon.svg';
import UserIconLight from './../../assets/icons/User_Icon_Login.svg';
import Logo from './../../assets/icons/logo_image.png';
import SevenHillsLogo from './../../assets/icons/seven-hills-logo.png';
import GDPR from './../../assets/icons/gdpr.png';
import Hippa from './../../assets/icons/hippa.png';
import DummyLogo from './../../assets/icons/dummy_logo.png';
import password_eye from './../../assets/icons/password_eye.svg';
import ResetLock from './../../assets/icons/reset_lock.svg';
import Plus from '../../assets/icons/plus.svg'
import Import from '../../assets/icons/import.svg'
import previewIcon from './../../assets/icons/preview.png';
import MediaSave from '../../assets/icons/media-save.svg'
import sevenHillsLogo from "./../../assets/icons/seven-hills.svg"
// import dashboardicon from "./../../assets/icons/dashboardIcon.svg"
import { ReactComponent as dashboardicon } from './../../assets/icons/dashboardIcon.svg';
import userIcon from "./../../assets/icons/userIcon.svg"
import patientIcon from "./../../assets/icons/patientIcon.svg"
import studiesicon from "./../../assets/icons/studies-icon.png"
import reporticon from "./../../assets/icons/reportIcon.svg"
import createTemplate from "./../../assets/icons/create-template.png"
import back from './../../assets/icons/back.svg'
import edit from "./../../assets/icons/edit.svg"
import {ReactComponent as UserCheck} from "./../../assets/icons/user-check.svg"
import deleteIcon from "./../../assets/icons/delete.svg"
import { ReactComponent as deleteImageIcon } from "./../../assets/icons/delete.svg"
import searchIcon from "./../../assets/icons/search.svg"
import closeSearch from "./../../assets/icons/close-search.svg"
import camera from './../../assets/icons/camera.svg'
import preview from './../../assets/icons/preview_icon.svg'
import previewReport from "./../../assets/icons/previewReport.svg"
import darkModePreviewReport from "./../../assets/icons/darkModePreviewReport.svg"
import rollbackReportIcon from "./../../assets/icons/rollbackReportIcon.svg"
import darkModeRollbackReportIcon from "./../../assets/icons/darkModeRollbackReportIcon.svg"
import reportAction from './../../assets/icons/reports_actions.svg'
import reschedule_Icon from './../../assets/icons/reschedule_icon.svg'
import appointmentPreview from './../../assets/icons/appointment_preview_watermark.png'
import confirmReport from './../../assets/icons/confirm_report_icon.svg'
import browse from './../../assets/icons/browse.svg'
import browseFolder from './../../assets/icons/browse_folder.svg'
import downarrow from "./../../assets/icons/downarrow.svg"
import lock_Icon_question from "./../../assets/icons/lock_icon_question.svg";
import Envelop_Icon from "./../../assets/icons/Envelop_Icon.svg";
import User_Icon from "./../../assets/icons/User_Icon.svg";
import uploadIcon from "./../../assets/icons/upload_icon.png";
import filterIcon from "./../../assets/icons/filter.svg"
import clearFilterIcon from "./../../assets/icons/clear-filters.png"
import defaultUserIcon from "./../../assets/icons/default-user-icon.svg"
import selectDropDownIcon from "./../../assets/icons/down-arrow.svg"
import calendarSelectIcon from "./../../assets/icons/calender-css.svg"
import timeIcon from "./../../assets/icons/time.svg"
import checkBoxIcon from "./../../assets/icons/check-icon.svg"
import backgroundImage from "./../../assets/icons/background-main.png"
import ClearFilters from "./../../assets/icons/clear-filters.png";
import viewImage from './../../assets/icons/viewImage.svg'
import { ReactComponent as redoIcon} from './../../assets/icons/redo-icon.svg'
import { ReactComponent as File_Icon } from '../../assets/icons/file.svg';
import { ReactComponent as GraphIcon } from '../../assets/icons/graph.svg';
import { ReactComponent as LabStudyIcon } from '../../assets/icons/lab-study.svg'
import { ReactComponent as IndicatorIcon } from '../../assets/icons/indicators.svg'
import {ReactComponent as sendReportIcon} from "./../../assets/icons/sendReport.svg"
import {ReactComponent as payOutIcon} from "./../../assets/icons/payout.svg"
import {ReactComponent as creditIcon} from "./../../assets/icons/credit.svg"
import {ReactComponent as copyIcon} from "./../../../assets/svgIcons/copy.svg"
import {ReactComponent as extraStorageIcon} from "./../../assets/icons/extra_storage_icon.svg"
import {ReactComponent as localAddressIcon} from "./../../assets/icons/localAddress.svg"
import {ReactComponent as machineIcon} from "./../../assets/icons/machine.svg"
import {ReactComponent as successIcon} from "./../../assets/icons/successIcon.svg"
import {ReactComponent as errorIcon} from "./../../assets/icons/errorIcon.svg"
import {ReactComponent as pendingIcon} from "./../../assets/icons/pendingIcon.svg"
import {ReactComponent as tickIcon} from './../../assets/icons/tick.svg'

const ICONS = {
  'arrow-down': arrowDown,
  'arrow-left': arrowLeft,
  'arrow-right': arrowRight,
  'arrow-left-small': arrowLeftSmall,
  'arrow-right-small': arrowRightSmall,
  selectDropDownIcon: selectDropDownIcon,
  calendarSelectIcon: calendarSelectIcon,
  timeIcon: timeIcon,
  checkBoxIcon:checkBoxIcon,
  backgroundImage:backgroundImage,
  back: back,
  edit: edit,
  delete: deleteIcon,
  downarrow: downarrow,
  filterIcon: filterIcon,
  clearFilterIcon: clearFilterIcon,
  defaultUserIcon: defaultUserIcon,
  searchIcon: searchIcon,
  preview: preview,
  reportAction: reportAction,
  reschedule: reschedule_Icon,
  confirm: confirmReport,
  closeSearch: closeSearch,
  appointmentPreview: appointmentPreview,
  calendar: calendar,
  cancel: cancel,
  clipboard: clipboard,
  close: close,
  LockIconQuestionMark: lock_Icon_question,
  Envelop_Icon: Envelop_Icon,
  User_Icon: User_Icon,
  Upload_Icon: uploadIcon,
  UserCheck: UserCheck,
  CrossIcon: CrossIcon,
  CheckIcon: CheckIcon,
  ClearFilters: ClearFilters,
  'dotted-circle': dottedCircle,
  'circled-checkmark': circledCheckmark,
  'delete-icon': deleteImageIcon,
//

  "user-side-menu":userSideMenuIcon,
  "patient-side-menu":patientSideMenuIcon,
  "report-side-menu":reportSideMenuIcon,
  "studies-side-menu":studiesSideMenuIcon,
  "create-template-side-menu":createTemplateSideMenuIcon,
  "appointment-side-menu":appointmentSideMenuIcon,
  "audit-trail-side-menu":auditTrailSideMenuIcon,
  "profile-side-menu":profileSideMenuIcon,
  "profile-edit-side-menu":profileEditSideMenuIcon,
  "setting-side-menu":settingSideMenuIcon,
  "hospital-side-menu":hospitalSideMenuIcon,
  "dashboard-side-menu":dashboardSideMenuIcon,
  "study-research-side-menu": studyReserachIcon,


  'chevron-down': chevronDown,
  'chevron-left': chevronLeft,
  'chevron-menu': chevronMenu,
  'chevron-next': chevronNext,
  'chevron-prev': chevronPrev,
  'chevron-right': chevronRight,
  'content-next': contentNext,
  'content-prev': contentPrev,
  'eye-visible': eyeVisible,
  'eye-hidden': eyeHidden,
  'external-link': externalLink,
  'group-layers': groupLayers,
  info: info,
  'icon-alert-outline': iconAlertOutline,
  'icon-alert-small': iconAlertSmall,
  'icon-clear-field': iconClearField,
  'icon-close': iconClose,
  'icon-play': iconPlay,
  'icon-pause': iconPause,
  'icon-search': iconSearch,
  'icon-status-alert': iconStatusAlert,
  'icon-transferring': iconTransferring,
  'info-action': infoAction,
  'info-link': infoLink,
  'launch-arrow': launchArrow,
  'launch-info': launchInfo,
  link: link,
  'list-bullets': listBullets,
  lock: lock,
  'logo-ohif-small': logoOhifSmall,
  'logo-dark-background': logoDarkBackGround,
  magnifier: magnifier,
  exclamation: exclamation,
  'notificationwarning-diamond': notificationwarningDiamond,
  pencil: pencil,
  'power-off': powerOff,
  profile: profile,
  'push-left': pushLeft,
  'push-right': pushRight,
  settings: settings,
  'side-panel-close-left': sidePanelCloseLeft,
  'side-panel-close-right': sidePanelCloseRight,
  'sorting-active-down': sortingActiveDown,
  'sorting-active-up': sortingActiveUp,
  'status-alert': statusAlert,
  'status-alert-warning': statusAlertWarning,
  'status-locked': statusLocked,
  'status-tracked': statusTracked,
  'status-untracked': statusUntracked,
  sorting: sorting,
  tracked: tracked,
  unlink: unlink,
  'panel-group-more': panelGroupMore,
  'panel-group-open-close': panelGroupOpenClose,
  'row-add': rowAdd,
  'row-edit': rowEdit,
  'row-hidden': rowHidden,
  'row-shown': rowShown,
  'row-lock': rowLock,
  'row-unlock': rowUnlock,
  'checkbox-checked': checkboxChecked,
  'checkbox-unchecked': checkboxUnchecked,
  'loading-ohif-mark': loadingOHIFMark,
  'notifications-info': notificationsInfo,
  'notifications-error': notificationsError,
  'notifications-success': notificationsSuccess,
  'notifications-warning': notificationsWarning,

  /** Tools */
  'copy': copyIcon,
  'toggle-dicom-overlay': toggleDicomOverlay,
  'tool-zoom': toolZoom,
  'tool-capture': toolCapture,
  'tool-layout': toolLayout,
  'tool-more-menu': toolMore,
  'tool-move': toolMove,
  'tool-window-level': toolWindow,
  'tool-annotate': toolAnnotate,
  'annotationPreference': annotationPreference,
  'tool-bidirectional': toolBidirectional,
  'tool-ellipse': toolElipse,
  'tool-circle': toolCircle,
  'tool-length': toolLength,
  'tool-stack-scroll': toolStackScroll,
  'tool-magnify': toolMagnify,
  'tool-flip-horizontal': toolFlipHorizontal,
  'tool-invert': toolInvert,
  'tool-rotate-right': toolRotateRight,
  'tool-cine': toolCine,
  'tool-crosshair': toolCrosshair,
  'tool-probe': toolProbe,
  'tool-angle': toolAngle,
  'tool-reset': toolReset,
  'tool-rectangle': toolRectangle,
  'tool-fusion-color': toolFusionColor,
  'tool-create-threshold': toolCreateThreshold,
  'tool-calibration': toolCalibration,
  'tool-point': toolCircle,
  'tool-freehand-line': toolFreehand,
  'tool-freehand-polygon': toolFreehandPolygon,
  'tool-polygon': toolPolygon,
  'tool-3d-rotate': iconToolRotate,
  'edit-patient': editPatient,
  'icon-mpr': iconMPR,
  'icon-next-inactive': iconNextInactive,
  'icon-next': iconNext,
  'icon-prev-inactive': iconPrevInactive,
  'icon-prev': iconPrev,
  'icon-upload': iconUpload,
  'navigation-panel-right-hide': navigationPanelRightHide,
  'navigation-panel-right-reveal': navigationPanelRightReveal,
  'tab-linear': tabLinear,
  'tab-patient-info': tabPatientInfo,
  'tab-roi-threshold': tabROIThreshold,
  'tab-segmentation': tabSegmentation,
  'tab-studies': tabStudies,
  'ui-arrow-down': uiArrowDown,
  'ui-arrow-up': uiArrowUp,
  'ui-arrow-left': uiArrowLeft,
  'ui-arrow-right': uiArrowRight,
  'checkbox-default': checkboxDefault,
  'checkbox-active': checkboxActive,
  'tool-referenceLines': referenceLines,
  'chevron-left-new': chevronLeftNew,
  'chevron-down-new': chevronDownNew,
  'settings-bars': settingsBars,
  'icon-rename': iconRename,
  'icon-add': iconAdd,
  'icon-delete': iconDelete,
  'icon-more-menu': iconMoreMenu,
  'icon-tool-brush': iconToolBrush,
  'icon-tool-eraser': iconToolEraser,
  'icon-tool-scissor': iconToolScissor,
  'icon-tool-shape': iconToolShape,
  'icon-tool-threshold': iconToolThreshold,
  'next-arrow': nextArrow,
  'prev-arrow': prevArrow,
  'viewport-status-tracked': viewportStatusTracked,
  'viewport-window-level': viewportWindowLevel,
  'dicom-tag-browser': dicomTagBrowser,
  /** New Tools */
  'icon-tool-freehand-roi': iconToolFreehandRoi,
  'icon-tool-livewire': iconToolLivewire,
  'icon-tool-spline-roi': iconToolSplineRoi,
  'icon-tool-ultrasound-bidirectional': iconToolUltrasoundBidirectional,
  'icon-tool-loupe': iconToolLoupe,
  'icon-tool-cobb-angle': iconToolCobbAngle,
  'icon-tool-window-region': iconToolWindowRegion,
  /** Old OHIF */
  'old-trash': oldTrash,
  'old-play': oldPlay,
  'old-stop': oldStop,
  /** ColorLut */
  'icon-color-lut': iconColorLUT,
  /** New Patient Info Toolbar */
  'icon-chevron-patient': iconChevronPatient,
  'icon-patient': iconPatient,
  'icon-settings': iconSettings,
  'icon-toolbar-back': iconToolbarBack,
  'icon-multiple-patients': iconMultiplePatients,
  /** Volume Rendering */
  'CT-AAA': CTAAA,
  'CT-AAA2': CTAAA2,
  'CT-Air': CTAir,
  'CT-Bone': CTBone,
  'CT-Bones': CTBones,
  'CT-Cardiac': CTCardiac,
  'CT-Cardiac2': CTCardiac2,
  'CT-Cardiac3': CTCardiac3,
  'CT-Chest-Contrast-Enhanced': CTChestContrastEnhanced,
  'CT-Chest-Vessels': CTChestVessels,
  'CT-Coronary-Arteries': CTCoronaryArteries,
  'CT-Coronary-Arteries-2': CTCoronaryArteries2,
  'CT-Coronary-Arteries-3': CTCoronaryArteries3,
  'CT-Cropped-Volume-Bone': CTCroppedVolumeBone,
  'CT-Fat': CTFat,
  'CT-Liver-Vasculature': CTLiverVasculature,
  'CT-Lung': CTLung,
  'CT-MIP': CTMIP,
  'CT-Muscle': CTMuscle,
  'CT-Pulmonary-Arteries': CTPulmonaryArteries,
  'CT-Soft-Tissue': CTSoftTissue,
  'DTI-FA-Brain': DTIFABrain,
  'MR-Angio': MRAngio,
  'MR-Default': MRDefault,
  'MR-MIP': MRMIP,
  'MR-T2-Brain': MRT2Brain,
  VolumeRendering: VolumeRendering,
  'action-new-dialog': actionNewDialog,
  /** LAYOUT */
  'layout-advanced-3d-four-up': layoutAdvanced3DFourUp,
  'layout-advanced-3d-main': layoutAdvanced3DMain,
  'layout-advanced-3d-only': layoutAdvanced3DOnly,
  'layout-advanced-3d-primary': layoutAdvanced3DPrimary,
  'layout-advanced-axial-primary': layoutAdvancedAxialPrimary,
  'layout-advanced-mpr': layoutAdvancedMPR,
  'layout-common-1x1': layoutCommon1x1,
  'layout-common-1x2': layoutCommon1x2,
  'layout-common-2x2': layoutCommon2x2,
  'layout-common-2x3': layoutCommon2x3,
  'tab-4d': tab4D,
  'Microphone': Microphone,
  'Stop': Stop,
  'SuccessCircle': SuccessCircle,

  /** New investigational use */
  'illustration-investigational-use': investigationalUse,

  'LoginBgImage': LoginBgImage,
  'MailIcon': MailIcon,
  'LockIcon': LockIcon,
  'UserIconLight': UserIconLight,
  'Logo': Logo,
  'SevenHillsLogo': SevenHillsLogo,
  'GDPR': GDPR,
  'Hippa': Hippa,
  'DummyLogo': DummyLogo,
  'PasswordEye': password_eye,
  'ResetLock': ResetLock,
  'Plus': Plus,
  'Import': Import,
  'previewIcon': previewIcon,
  'MediaSave': MediaSave,
  'sevenHillsLogo': sevenHillsLogo,
  "dashboardIcon": dashboardicon,
  "userIcon": userIcon,
  "patientIcon": patientIcon,
  "studiesIcon": studiesicon,
  "reportIcon": reporticon,
  "createTemplate": createTemplate,
  "camera": camera,
  'browse': browse,
  'browseFolder': browseFolder,
  'brain' : brain,
  'chestBones': chestBones,
  'nurse': nurse,
  'maleIcon': maleIcon,
  'femaleIcon': femaleIcon,
  'othersIcon': othersIcon,
  'radiologist': radiologist,
  'clinician': clinician,
  'cardiologist': cardiologist,
  'frontDesk': frontDesk,
  'port' : port,
  'plan': plan,
  'superAdmin' : superAdmin,
  'viewImage':viewImage,
  'file-icon': File_Icon,
  'uploadImage': uploadImage,
  'maximize-icon': maximizeIcon,
  'graph-icon': GraphIcon,
  'indicator-icon': IndicatorIcon,
  'redo-icon': redoIcon,
  'lab-study-icon': LabStudyIcon,
  'verify-report-icon' : verifyReport,
  sendReportIcon,
  'payOutIcon' : payOutIcon,
  'creditIcon' : creditIcon,
  'extraStorageIcon': extraStorageIcon,
  'localAddressIcon': localAddressIcon,
  'machineIcon': machineIcon,
  previewReport: previewReport,
  darkModePreviewReport: darkModePreviewReport,
  rollbackReportIcon: rollbackReportIcon,
  darkModeRollbackReportIcon: darkModeRollbackReportIcon,
  'successIcon': successIcon,
  'errorIcon': errorIcon,
  'pendingIcon': pendingIcon,
  'copyIcon': copyIcon,
  'tickIcon': tickIcon,
};

function addIcon(iconName, iconSVG) {
  if (ICONS[iconName]) {
    console.warn(`Icon ${iconName} already exists.`);
  }

  ICONS[iconName] = iconSVG;
}

/**
 * Return the matching SVG Icon as a React Component.
 * Results in an inlined SVG Element. If there's no match,
 * return `null`
 */
export default function getIcon(key, props) {
  const icon = ICONS[key];

  if (!key || !icon) {
    return React.createElement('div', null, 'Missing Icon');
  }

  if (typeof icon === 'string' && icon.endsWith('.png')) {
    return React.createElement('img', { src: icon, ...props });
  } else {
    return React.createElement(icon, props);
  }
}

export { getIcon, ICONS, addIcon };
